'use client';

import { useTranslations } from 'next-intl';
import { ApplicationAutomationIds, automationId } from '@terra/shared-utils';
import { Badge } from '../../../components/badge';
import { Tooltip } from '../../../components/tooltip';
import type { EndpointMemoryCreationMethod } from './can-remove-endpoint-memory';

type EndpointMemorySourceBadgeProps = {
  creationMethod?: EndpointMemoryCreationMethod;
};

export function EndpointMemorySourceBadge({
  creationMethod,
}: EndpointMemorySourceBadgeProps) {
  const t = useTranslations('designSystem.applicationAssets.drawer.memories');
  const method = creationMethod ?? 'manual';

  return (
    <Tooltip title={t(`creationMethodTooltip.${method}`)}>
      <Badge
        variant="fill"
        size="sm"
        {...automationId(
          ApplicationAutomationIds.assetsEndpointDrawer,
          `tab-memories-source-${method}`,
        )}
      >
        {t(`creationMethod.${method}`)}
      </Badge>
    </Tooltip>
  );
}
